module.exports = __webpack_public_path__ + "static/media/sentia-vlieg.15a57d56.jpg";